import { PAYMENT_TYPES } from '@vend/business-components'
import { FulfilmentType } from '../models/fulfilment'

export const convertFulfillmentType = (type: FulfilmentType | undefined) => {
  switch (type) {
    case FulfilmentType.DELIVERY:
      return 'DELIVERY'
    case FulfilmentType.PICKUP:
      return 'PICKUP'
    default:
      return undefined
  }
}

// Create the reverse lookup map once at module level for performance
const PAYMENT_TYPE_ID_TO_NAME_MAP = Object.entries(PAYMENT_TYPES).reduce(
  (map, [key, value]) => {
    map[value] = key
    return map
  },
  {} as Record<number, string>
)

/**
 * Maps a payment type ID to its corresponding standard enum name
 * @param typeId The numeric payment type ID
 * @returns The standard enum name (e.g., "CASH", "CREDIT_CARD", etc.)
 */
export const convertPaymentTypeIdToEnum = (typeId: number): string => {
  return PAYMENT_TYPE_ID_TO_NAME_MAP[typeId] || 'UNKNOWN'
}
